import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { BN_ZERO } from '@polkadot/util';
import { of } from '@polkadot/x-rxjs';
import { map, switchMap } from '@polkadot/x-rxjs/operators';
import { deriveCache, memo } from "../util/index.mjs";
import { filterEras } from "./util.mjs";
var CACHE_KEY = 'eraPoints';

function mapValidators(_ref) {
  var individual = _ref.individual;
  return _toConsumableArray(individual.entries()).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        points = _ref3[1];

    return points.gt(BN_ZERO);
  }).reduce(function (result, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        validatorId = _ref5[0],
        points = _ref5[1];

    result[validatorId.toString()] = points;
    return result;
  }, {});
}

function mapPoints(eras, points) {
  return eras.map(function (era, index) {
    return {
      era: era,
      eraPoints: points[index].total,
      validators: mapValidators(points[index])
    };
  });
}

export function _erasPoints(instanceId, api) {
  return memo(instanceId, function (eras, withActive) {
    if (!eras.length) {
      return of([]);
    }

    var cached = withActive ? [] : eras.map(function (era) {
      return deriveCache.get("".concat(CACHE_KEY, "-").concat(era.toString()));
    }).filter(function (value) {
      return !!value;
    });
    var remaining = filterEras(eras, cached);
    return !remaining.length ? of(cached) : api.query.staking.erasRewardPoints.multi(remaining).pipe(map(function (points) {
      var query = mapPoints(remaining, points);
      !withActive && query.forEach(function (q) {
        return deriveCache.set("".concat(CACHE_KEY, "-").concat(q.era.toString()), q);
      });
      return eras.map(function (era) {
        return cached.find(function (cached) {
          return era.eq(cached.era);
        }) || query.find(function (query) {
          return era.eq(query.era);
        });
      });
    }));
  });
}
export function erasPoints(instanceId, api) {
  return memo(instanceId, function () {
    var withActive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return api.derive.staking.erasHistoric(withActive).pipe(switchMap(function (eras) {
      return api.derive.staking._erasPoints(eras, withActive);
    }));
  });
}